import { Sentry } from "./sentryInstrument";


async function setSECodeCookie(endpoint, retriesLeft) {
  const currentParams = new URLSearchParams(document.location.search);
  const url = new URL(endpoint);
  if (!currentParams.has("se")) {
	return;
  }
  url.searchParams.append("se", currentParams.get("se"));
  url.searchParams.append("seref", document.referrer);

  try {
		const response = await fetch(url.toString());
		if (!response.ok) {
			throw new Error(`Unexpected ${response.statusText} response ${response.status} from ${url}`);
		}
  } catch (error) {
		if (retriesLeft > 0) {
			await new Promise(r => setTimeout(r, 2000));	// NOTE: sleep 2 seconds
			await setSECodeCookie(url, retriesLeft - 1);
		} else {
			if (Sentry && Sentry.captureException) {
				Sentry.captureException(error);
			}
		}
  }
}

window.addEventListener("DOMContentLoaded", () => {
  if (window.setSECodeURL) {
	// Add .catch() to prevent unhandled promise rejection
	setSECodeCookie(window.setSECodeURL, 4).catch(error => {
		if (Sentry && Sentry.captureException) {
			Sentry.captureException(error);
		} else {
			console.error("Error setting SE code cookie", error);
		}
	});
  }
});
